import React, { Component } from "react";
import { profile, GET, PUT, alert, loading, Status } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo-lsc-b.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      array_link: [],
      user_profile: profile,
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {
    const { user_profile } = this.state;
    if (user_profile?.expired < new Date().getTime()) {
      localStorage.removeItem("scp-profile");
      alert(
        "/login",
        "warning",
        "แจ้งเตือน",
        "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
      );
    }
  };
  componentMenu = () => {
     const { user_profile } = this.state;
    return (
      <div>
        <div>
          <a
            className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start"
            style={{ paddingTop: 12, paddingBottom: 12 }}
            href="/game"
          >
            เติมเกม
          </a>
        </div>
        <div>
          <a
            className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start"
            style={{ paddingTop: 12, paddingBottom: 12 }}
            href="/mobile"
          >
            เติม coin
          </a>
        </div>
        <div>
          <a
            className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start"
            style={{ paddingTop: 12, paddingBottom: 12 }}
            href="/giftshop"
          >
            Gift Shop
          </a>
        </div>
        {!user_profile ?
        (<div>
          <a
            className="btn btn-outline-primary rounded-0 px-3 border-0 w-100 text-start"
            style={{ paddingTop: 12, paddingBottom: 12 }}
            href="/login"
          >
            เข้าสู่ระบบ
          </a>
        </div>):(<div>
                     <button
                    className="btn btn-outline-danger rounded-0 px-3 border-0 w-100 text-start"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    onClick={async()=>{if(await alert("","info","ออกจากระบบ","ยืนยันการออกจากระบบหรือไม่","ออกจากระบบ","ยกเลิก")){localStorage.removeItem("scp-profile");window.location.href = "/login";}}}
                  >
                    ออกจากระบบ
                  </button>
                  </div>
        )
  }
  {user_profile && (<span>{Status(user_profile?.fullname,"info")}</span>)}
      </div>
    );
  };

  render() {
    const { user_profile } = this.state;
    return (
      <div className="hpx-50">
        <Navbar
          className="py-0 bg-light position-fixed w-100"
          style={{ zIndex: 1000 }}
          expand="xl"
        >
          <div className="container px-3 px-xl-4">
            <Navbar.Brand href="/" className="fw-bold text-dark">
              <div className="position-relative">
                <img
                  alt="logo"
                  src={LOGO}
                  height={30}
                  style={{ objectFit: "contain" }}
                  className="pointer"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              className="border-0"
              aria-controls="basic-navbar-nav"
            />
            <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
              <Nav className="ms-auto py-0">
                <div className="d-none d-xl-flex align-items-center px-3">
                  <a
                    className="btn btn-outline-primary rounded-0 px-3 border-0"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    href="/game"
                  >
                    เติมเกม
                  </a>
                  <a
                    className="btn btn-outline-primary rounded-0 px-3 border-0"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    href="/mobile"
                  >
                    เติม coin
                  </a>
                  <a
                    className="btn btn-outline-primary rounded-0 px-3 border-0"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    href="/giftshop"
                  >
                    Gift Shop
                  </a>
                   {user_profile && (<span>{Status(user_profile?.fullname,"info")}</span>)}
                  {!user_profile ?
                 ( <a
                    className="btn btn-outline-primary rounded-0 px-3 border-0"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    href="/login"
                  >
                    เข้าสู่ระบบ
                  </a>):(
                     <button
                    className="btn btn-outline-danger rounded-0 px-3 border-0"
                    style={{ paddingTop: 12, paddingBottom: 12 }}
                    onClick={async()=>{if(await alert("","info","ออกจากระบบ","ยืนยันการออกจากระบบหรือไม่","ออกจากระบบ","ยกเลิก")){localStorage.removeItem("scp-profile");window.location.href = "/login";}}}
                  >
                    ออกจากระบบ
                  </button>
                  )
  }
                </div>
                <div
                  className="d-block d-xl-none mb-5 pt-4"
                  style={{ height: "80vh" }}
                >
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}
